import $ from 'cash-dom';

const POPUP_CONTENT_SELECTOR = '.popup-content';

class Popup {

    constructor(config) {
        config = typeof config === "undefined" ? {} : config;
        this._initPopupProperties(config);
        this._initPopupHandlers();
    }

    static get POPUP_CONTENT_SELECTOR() {
        return POPUP_CONTENT_SELECTOR;
    }

    _getPopupSelector() {
        return '#fm-popup';
    }

    _initPopupProperties(config) {
        this._$fmPopup = $(this._getPopupSelector());
        this._$popupContent = this._$fmPopup.find(POPUP_CONTENT_SELECTOR);

        if (typeof config.containerClass !== "undefined") {
            this.containerClass = config.containerClass;
            this._$popupContent.closest('.popup-container').addClass(this.containerClass);
        }


        this.noCloseOnPopup = false;
        if (typeof config.noCloseOnPopup !== "undefined" && config.noCloseOnPopup) {
            this.noCloseOnPopup = true;
        }

        this._cloneOriginalContent = typeof config.cloneOriginalContent !== "undefined" && config.cloneOriginalContent;
    }

    _sendCloseEvent(triggerName) {
        let dataEl = this._$popupContent.find('[data-close-event-suffix]');

        if (dataEl && dataEl.length) {
            let suffix = dataEl.attr('data-close-event-suffix'),
                prefix = dataEl.attr('data-close-event-prefix') ?? 'popup',
                category = dataEl.attr('data-close-event-category') ?? 'not_detected';

            if (triggerName && suffix) {
                if (typeof GAEvents !== 'undefined') {
                    GAEvents.sendEvent(
                        category,
                        'close',
                        prefix + triggerName + suffix,
                    );
                }
            }
        }

        let biDataEl = this._$popupContent.find('[data-bi-close-event]');

        if (biDataEl && biDataEl.length) {
            let event = biDataEl.attr('data-bi-close-event');

            if ((triggerName === 'CloseArea' || triggerName === 'CloseXbtn') && event) {
                Alooma.aloomaSendEvent(event, Alooma.aloomaPageData);
            }
        }
    }

    _initPopupHandlers() {
        this._initPopupClick();

        this._$fmPopup.find('.popup-close-button').on('click', () => {
            this._sendCloseEvent('CloseXbtn');
            this.hide();
        });

        if (!this.noCloseOnPopup) {
            this._$fmPopup.find('.popup-container').on('click', (event) => {
                if (event.target.getAttribute('data-href') === null && event.target.closest('[data-href]') === null) {
                    event.stopPropagation();
                }
            });
        }

        $(window).on('resize', () => {
            this._setCssProperties();
        });
    }

    _initPopupClick() {

        if (!this.noCloseOnPopup) {

            this._$fmPopup.on('click', (e) => {
                if ($(e.target).attr('id') === 'fm-popup') {
                    this._sendCloseEvent('CloseArea');
                }

                this.hide();
            });
        }
    }

    hide() {
        this._$fmPopup.attr('class', 'fm-popup');
        this._$fmPopup.hide();
        this._$popupContent.html(null);
        this._triggerPopupHide();
    }

    _triggerPopupHide() {
        $(this._$fmPopup).trigger('popupHide');
    }

    onPopupHide(handler) {
        if (typeof handler === 'function') {
            $(this._$fmPopup).on('popupHide', handler);
        }
    }

    /**
     * Shows html content inside popup.
     * Usage:
     * ```
     * const popup = new Popup();
     *
     * popup.show({html: '<div>Some content</div>'});
     * ```
     * @param {string|Cache|null} content
     * @param {string|null} popupClass
     */
    show(content, popupClass = null) {
        if (content && typeof content === 'object' && content instanceof $) {
            this._$popupContent.html(null);
            this._$popupContent.append(this._cloneOriginalContent ? content.clone() : content);
        } else {
            this._$popupContent.html(content);
        }

        if (popupClass) {
            this._$fmPopup.addClass(popupClass);
        }

        this._showPopupElement();
    }

    _showPopupElement() {
        this._$fmPopup.css('display', 'flex');
        this._setCssProperties();
    }

    _setCssProperties() {
        const popupHeight = this._$popupContent.outerHeight();
        document.documentElement.style.setProperty('--popup-half-height', (popupHeight / 2) + 'px');
    }

    findContent() {
        return this._$fmPopup.find(POPUP_CONTENT_SELECTOR);
    }
}

export default Popup;
